"use strict";

import angular from "angular";
import ngCookies from "angular-cookies";
import uiRouter from "@uirouter/angularjs";

/* controllers */
import tourCtrl from "./tourCtrl";
import updateListCtrl from "./updatesListCtrl";
import trailerCtrl from "./trailerCtrl";
import VideoContentCtrl from "./videoContentCtrl";
import ModelCtrl from "./modelCtrl";
import ImageCtrl from "./imageCtrl";

/* @ngInject */
export default angular
  .module("features", [ngCookies, uiRouter])
  .controller(trailerCtrl.UID, trailerCtrl)
  .controller(updateListCtrl.UID, updateListCtrl)
  .controller(VideoContentCtrl.UID, VideoContentCtrl)
  .controller(ModelCtrl.UID, ModelCtrl)
  .controller(ImageCtrl.UID, ImageCtrl)
  .controller(tourCtrl.UID, tourCtrl).name;



// WEBPACK FOOTER //
// ./src/app/features/index.js